<template>
  <svg :width="width" :height="height">
    <g :transform="graphTransform">
      <orthogonal-axes
         ref="axes"
         :xLabelRotate="xLabelRotate"
         :width="graphWidth"
         :height="graphHeight"
         :xTitle="xTitle"
         :yTitle="yTitle"
         :xFormatter="xFormatter"
         :yFormatter="yFormatter"
         :x="x"
         :y="y" >
      </orthogonal-axes>
      <template v-for="i in keys.length" >
        <popover
           v-for="(bar, j) in stackedData[i - 1]"
           :key="i + '_' + j"
           :content="yFormatter(bar[1] - bar[0])"
           :delay="100"
           :hideDelay="100" >
          <rect
             @click="handleSelect(bar)"
             class="bar hoverable"
             :x="x(bar.data.x)"
             :y="y(bar[1])"
             :width="Math.max(x.bandwidth(), 0)"
             :height="Math.max(y(bar[0]) - y(bar[1]), 0)"
             :style="{fill: z(keys[i - 1])}" >
          </rect>
        </popover>
      </template>
      <rect
         v-for="(bar, j) in stackedData[0]"
         :class="selectableClass(bar, ['bar', 'overlay', 'hoverable'])"
         :key="'overlay-' + j"
         :x="x(bar.data.x)"
         :y="y(stackedData[stackedData.length - 1][j][1])"
         :width="Math.max(x.bandwidth(), 0)"
         :height="Math.max(y(bar[0]) - y(stackedData[stackedData.length - 1][j][1]), 0)"
         fill="none" />
      <template v-if="showLegend" >
        <draggable v-if="draggableLegend" ref="draggableLegend" >
          <graph-legend :keys="keyColors" :x="graphWidth - legendWidth" :width="legendWidth" >
          </graph-legend>
        </draggable>
        <graph-legend v-else :keys="keyColors" :x="graphWidth - legendWidth" :width="legendWidth" >
        </graph-legend>
      </template>
    </g>
  </svg>
</template>

<script>
import Bar from './Bar.vue'
import * as d3 from 'd3'
import * as d3Chromatic from 'd3-scale-chromatic'
import Popover from 'd3vue/components/Popover.vue'
import OrthogonalAxes from './OrthogonalAxes.vue'
import DraggableLegend from '../mixins/draggable-legend.js'

export default {
  extends: Bar,
  mixins: [
    DraggableLegend
  ],
  components: {
    Popover: Popover,
  },
  props: {
    keys: {
      type: Array,
      required: true
    },
    draggableLegend: {
      type: Boolean,
      default: true
    },
    colorScale: {
      default: () => {
        return d3.scaleSequential(d3Chromatic.interpolateRainbow)
      }
    }
  },
  computed: {
    stack () {
      return d3.stack().keys(this.keys)
    },
    stackedData () {
      return this.stack(this.data)
    },
    z () {
      const rainbow = this.colorScale.domain([0, this.keys.length])
      return d3.scaleOrdinal(this.keys.map((k, i) => rainbow(i))).domain(this.keys)
    },
    keyColors () {
      return this.keys.map(k => {
        return {
          label: k,
          color: this.z(k)
        }
      })
    }
  },
  methods: {
    selectData (d) {
      return d.data
    },
    selectKey (d) {
      return d.x
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/StackedBar.vue